import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=56a8c57c&scoped=true&"
import script from "./PlanItem.vue?vue&type=script&lang=js&"
export * from "./PlanItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=56a8c57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8c57c",
  null
  
)

/* custom blocks */
import block0 from "./PlanItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports